export class NamirasoftAccountReqHeader
{
    TOKEN()
    {
        return `ns-account-token`;
    }
}